import { BaseModel } from './util';
import { File } from './file';

export class LeagueFieldBaseValue extends BaseModel {
  id: number;
  value: string;
  file: File;
  valueText: string;
}
